import React, { useState } from "react";
import { FiLock, FiUser, FiEye, FiEyeOff } from "react-icons/fi";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);

      const response = await fetch(`${BASE_URL}/users/admin-login.php`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert("Welcome Admin!");
        window.location.href = "/babafakruddin/admin/dashboard";
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert("Login failed: " + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-slate-800 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl border border-white/20 p-8 space-y-6">
        <div className="flex justify-center">
          <img
            src="../assets/logo.jpg"
            alt="Admin Logo"
            className="h-20 w-20 object-cover rounded-full shadow-lg border-4 border-orange-500"
          />
        </div>
        <h2 className="text-center text-3xl font-bold text-orange-400">
          Admin Login
        </h2>
        <form onSubmit={handleLogin} className="space-y-5">
          <div className="flex items-center bg-neutral-700 border border-orange-400/40 rounded-xl px-4 py-3 focus-within:ring-2 ring-orange-400">
            <FiUser className="text-orange-300 text-lg mr-3" />
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="bg-transparent outline-none text-orange-100 w-full placeholder-orange-200"
              required
            />
          </div>

          <div className="flex items-center bg-neutral-700 border border-orange-400/40 rounded-xl px-4 py-3 focus-within:ring-2 ring-orange-400">
            <FiLock className="text-orange-300 text-lg mr-3" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent outline-none text-orange-100 w-full placeholder-orange-200"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="ml-3 text-orange-300 hover:text-orange-100"
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold text-lg transition-all duration-300 shadow-lg"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
